import styled from "styled-components";

export const SignUpButton = styled.button`
  background: ${({ $backgroundColor }) =>
    $backgroundColor ? `#${$backgroundColor}` : "#153B60"};
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 22px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, filter 0.2s ease;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 150px;
  align-self: end;

  &:hover {
    filter: brightness(0.92);
  }

  &:active {
    transform: translateY(1px);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.8;
  }

  @media (max-width: 480px) {
    width: 100%;
    align-self: stretch;
    font-size: 0.9rem;
    padding: 0.65rem 1.25rem;
    min-height: 44px;
  }
`;
